import React from "react";
import {Chip, useTheme} from "@mui/material";

interface ResourceFilterChipProps {
    label: string;
    active: boolean;
    onClick: () => void;
    color?: string;
}

export function ResourceFilterChip({label, active, onClick, color}: ResourceFilterChipProps) {
    const theme = useTheme();
    return (
        <Chip
            label={label}
            size="small"
            onClick={onClick}
            sx={{
                fontWeight: 600,
                fontSize: "0.75rem",
                cursor: "pointer",
                backgroundColor: active
                    ? (color ?? theme.palette.primary.main)
                    : "transparent",
                color: active ? "#fff" : theme.palette.text.secondary,
                border: active ? "none" : `1px solid ${theme.palette.divider}`,
                "&:hover": {
                    backgroundColor: active
                        ? (color ?? theme.palette.primary.main)
                        : theme.palette.action.hover,
                },
            }}
        />
    );
}
